// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserNavigation_wrap__ol99v","item":"UserNavigation_item__w22_W","iconWrapper":"UserNavigation_iconWrapper__0jOWA","quantity":"UserNavigation_quantity__eIqqX"};